$('.col3_ans').hide();
$('.col3_question').on('click', function () {
    $(this).find('.col3_ans').toggle();
    $(this).find('div:nth-child(2)').toggleClass('rotateIcon');
})

$('.collapse').hide();
$('.card-header').on('click', function () {
    $(this).parent('.card').find('.collapse').toggle();
    $(this).find('div').toggleClass('rotateIcon');
})

$('.header_btn svg').on('click', function () {
    $('.header_sidebar').slideToggle();
});

$('#popup,.popup').on('click', function () {
    $('.sorry_popup').show();
});

$('.sorry_btn a:last-child()').on('click', function () {
    $('.sorry_popup').hide();
});

$('.video_box video').hide();
$('.video_box').on('click', function () {
    $(this).find('img').hide();
    $(this).find('video').show();
    $(this).find('video').play();
});

function welcome() {
    $('.welcome_btn a').on('click', function () {
        $(this).parents('.shopify-section').hide();
        $(this).parents().eq(4).next().show();
    });

    $(".col5_btn_1 a").click(function () {
        let heightValue = $("#inputHeight").val();
        let heightInchValue = $("#inputHeightInch").val();

        let weightValue = $("#inputWeight").val();
        let inputWeightLbsValue = $("#inputWeightLbs").val();

        let inputTargetWeightValue = $("#inputTargetWeight").val();
        let inputTargetWeightLbsValue = $("#inputTargetWeightLbs").val();

        let weightUnitLable = 'Kg'

        const weightUnit = $("input[name=weightUnit]:checked").val();
        const heightUnit = $("input[name=heightUnit]:checked").val();



        if (weightValue === '' || heightValue === '' || inputTargetWeightValue === '') {
            alert("Please Enter All Fields");
            return;
        }

        if (weightUnit == "pound") {
            weightValue = poundsToKilograms(weightValue);
            inputTargetWeightValue = poundsToKilograms(inputTargetWeightValue);
            weightUnitLable = 'Lbs';
        }

        if (weightUnit == "stone") {
            weightValue = stoneToKg(weightValue, inputWeightLbsValue);
            inputTargetWeightValue = stoneToKg(inputTargetWeightValue, inputTargetWeightLbsValue);
            weightUnitLable = 'St';
        }

        if (heightUnit == "feet") {
            console.log(heightValue, heightInchValue)
            heightValue = feetToCentimeters(heightValue, heightInchValue);
        }

        if (heightUnit == "inch") {
            heightValue = cmToInches(heightValue);
        }

        const inputWeight = weightValue;
        const inputHeight = heightValue;
        const inputTargetWeight = inputTargetWeightValue;

        const _inputWeight = parseInt(weightValue);
        const _inputTargetWeight = parseInt(inputTargetWeightValue);


        if (isNaN(inputWeight) || isNaN(inputHeight)) {
            alert("Please enter valid numbers for Height and Weight");
            return;
        }

        if (_inputTargetWeight !== '' && _inputTargetWeight >= _inputWeight) {
            alert("Target weight must be lower than the current weight");
            return;
        }

        console.log(`Weight: ${inputWeight}, Height: ${inputHeight}, Target Weight: ${inputTargetWeight}, Weight Unit: ${weightUnit}, Height Unit: ${heightUnit}`)

        const get_BMI = (inputWeight / (inputHeight * inputHeight)) * 10000;

        console.log(get_BMI)

        const validBMIValue = (currentPage == 'maintenance-take-the-quiz') ? 22.5 : 27;
        if (get_BMI > validBMIValue) {
            $(this).parents().eq(5).find('#getBMI').text(get_BMI.toFixed(1));
            let pwl = inputWeight * 0.2;
            console.log(pwl)
            if (weightUnit == "pound") {
                pwl = kilogramsToPounds(pwl);
            }

            if (weightUnit == "stone") {
                pwl = kgToStone(pwl);
            }
            $(this).parents().eq(5).find('#getPWL').text(`(${weightUnitLable}): ${pwl.toFixed(1)}`);
            $(this).parents('.col5_main').find('.col5_box_txt').hide();
            $(this).parents('.col5_main').find('.col5_box_txt_1').show();
            // $(".bmiBtn a").click(function() {
            //   $(this).parents().eq(5).hide();
            //   $(this).parents().eq(5).next().show(); 
            // });

        }
        else {
            $(this).parents().eq(5).hide();
            $(this).parents().eq(5).next().show();
        }

        $('html, body').animate({ scrollTop: 0 }, 0);

    });


}

$('input[name=weightUnit]').change(function (e) {
    const weightUnit = $("input[name=weightUnit]:checked").val();
    if (weightUnit == "kilogram") {
        $('.weightUnitText').text('kg')
    }

    if (weightUnit == "stone") {
        $('.weightUnitText').text('st')
        $('.bmi-height-block--weight').addClass('active')
        $('.bmi-height-block--target-weight').addClass('active')

    } else {
        $('.bmi-height-block--weight').removeClass('active')
        $('.bmi-height-block--target-weight').removeClass('active')
    }

    if (weightUnit == "pound") {
        $('.weightUnitText').text('lbs')
    }
});

$('input[name=heightUnit]').change(function (e) {
    const heightUnit = $("input[name=heightUnit]:checked").val();
    if (heightUnit == "centimetre") {
        $('.heightUnitText').text('cm')
    }

    if (heightUnit == "feet") {
        $('.heightUnitText').text('ft')
        $('.bmi-height-block--height').addClass('active')
        $('#inputHeight').attr('placeholder', 'Enter Height Feet')
    } else {
        $('.bmi-height-block--height').removeClass('active')
        $('#inputHeight').attr('placeholder', 'Enter Height')
    }
});


function kgToStone(kg) {
    const kgToStoneConversionFactor = 0.157473;
    console.log("kgToStone: " + kg * kgToStoneConversionFactor)
    return kg * kgToStoneConversionFactor;
}


function stoneToKg(stone, pounds) {
    const kgFromStone = stone * 6.35029;
    const kgFromPounds = pounds * 0.453592;
    return kgFromStone + kgFromPounds;
}


function poundsToKilograms(pounds) {
    const conversionFactor = 0.453592;
    console.log("poundsToKilograms: " + pounds * conversionFactor)
    return pounds * conversionFactor;
}

function feetToCentimeters(feet, inches) {
    const totalInches = (parseInt(feet) * 12) + parseInt(inches);  // Convert feet to inches and add the extra inches
    const centimeters = totalInches * 2.54;    // 1 inch = 2.54 cm
    console.log("feetToCentimeters: " + centimeters)
    return centimeters;
}

function cmToInches(cm) {
    const conversionFactor = 0.393701;
    console.log("cmToInches: " + cm * conversionFactor)
    return cm * conversionFactor;
}

function kilogramsToPounds(kilograms) {
    const conversionFactor = 2.20462;
    console.log("kilogramsToPounds: " + kilograms * conversionFactor)
    return kilograms * conversionFactor;
}

$('.med_his_btn a').on('click', function () {
    $(this).parents().eq(5).hide()
    $(this).parents().eq(5).next().show()
});


$('#medical-history main .shopify-section:nth-child(11) .col5_inline_1 input').attr('type', 'radio');
$('#medical-history main .shopify-section:nth-child(13) .col5_inline_1 input').attr('type', 'radio');
$('#medical-history main .shopify-section:nth-child(7) .col5_inline_1 input').attr('type', 'radio');
$('#medical-history main .shopify-section:nth-child(2) .col5_inline_1 input').attr('type', 'radio');
$('#medical-history main .shopify-section:nth-child(3) .col5_inline_1 input').attr('type', 'radio');
$('#medical-history main .shopify-section:nth-child(9) .col5_inline_1 input').attr('type', 'radio');
$('#medical-history main .shopify-section:nth-child(10) .col5_inline_1 input').attr('type', 'radio');
$('#diet-and-lifestyle main .shopify-section:nth-child(4) .col5_inline_1 input').attr('type', 'radio');

$(document).ready(function () {
    $('.mh-first-input').click(function (e) {
        $('.medical-history').first().addClass('active')
        $.each($('.progress-bar'), function (indexInArray, list) {
            $(list).find('li').first().addClass('active')
        });
        /* const medical_history = $('.medical-history.active');
        for (let index = 0; index < medical_history.length; index++) {
            $.each($('.progress-bar'), function (indexInArray, list) {
                $(list).find('li').eq(index).addClass('active')
            });
        } */
    });
});

function dietandlifestyle() {

    $('.col5_btn a').on('click', function () {
        let _this = $(this);
        let conditions = [];
        let getAns = $(this).parent().parent().find('input[data-name="checkbox"]:checked');
        getAns.each(function (i, v) {
            conditions.push($(v).attr('data-condition'));
        });
        if (conditions.length == 0) {
            alert('Please select options');
        }
        else if (conditions.includes("fail")) {
            $('#diet-and-lifestyle main .shopify-section , #medical-history main .shopify-section').hide();
            $('#diet-and-lifestyle main .shopify-section:last-child , #medical-history main .shopify-section:last-child').show();
        }
        else {
            if (_this.parent().parent().find('input[type="radio"]:checked').val() == 'Male') {
                _this.parents().eq(5).hide();
                _this.parents().eq(5).next().next().show();
            }
            else if (_this.parent().parent().find('input[type="radio"]:checked').val() == 'Yes') {
                _this.parents().eq(5).hide();
                $('#medical-history main .shopify-section:nth-last-child(2)').show();
            }
            else if (_this.parents('main').find('shopify-section:nth-child(10) .col5_inline_1 input[type="radio"]:checked').val() == 'Pass') {
                _this.parents().eq(9).hide();
                $('#medical-history main .shopify-section:nth-last-child(3)').show();
            }
            else {
                _this.parents().eq(5).hide();
                _this.parents().eq(5).next().show();
            }
            console.log(_this.parents())
            _this.parents('.medical-history').addClass('active')
            const medical_history = $('.medical-history.active');
            for (let index = 0; index < medical_history.length; index++) {
                $.each($('.progress-bar'), function (indexInArray, list) {
                    $(list).find('li').eq(index).addClass('active')
                });
            }
            console.log(window.innerWidth)
            $('html, body').animate({ scrollTop: 0 }, 0);
        }
    });
}
dietandlifestyle();
welcome()

$(document).ready(function () {

    const medical_history = $('.medical-history');
    const total_medical_history = medical_history.length

    var list = "<ul class='progress-bar'>"
    for (let index = 0; index < total_medical_history; index++) {
        list += '<li></li>'
    }
    list += '</ul>'


    $('.cs-testimonial .slick-slider').slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-left"></i></span>',
        nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-right"></i></span>',
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.app-welcome-steps__carousel').slick({
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-left"></i></span>',
        nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-right"></i></span>'
    });

    $('.mounjaro-maint__plans__carousel').slick({
        infinite: true,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-left"></i></span>',
        nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-right"></i></span>'
    });

    // $('').slick({
    //     infinite: true,
    //     autoplay: false,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     arrows: true,
    //     dots: false,
    //     prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-left"></i></span>',
    //     nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-right"></i></span>'
    // });

    $('.main-video-carousel').owlCarousel({
        items: 1,
        merge: false,
        loop: false,
        margin: 10,
        video: true,
        lazyLoad: true,
        center: true,
        responsive: {
            480: {
                items: 1
            },
            600: {
                items: 1
            }
        }
    })
    $('.logos-carousel-block .slick-slider').slick({
        infinite: true,
        autoplay: true,

        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,

        //prevArrow: '<span class="product-dec-icon product-dec-prev"><i class="sli sli-arrow-left"></i></span>',
        //nextArrow: '<span class="product-dec-icon product-dec-next"><i class="sli sli-arrow-right"></i></span>',
        responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }
        ]
    });



    $('.upsell-list').hide();
    $('.upsell-list').attr('href', 'javascript:;')
    $('.upsell-toggle').on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('.upsell-list').slideToggle();
    });

    $('.validate-age').change(function (e) {
        e.preventDefault();
        if ($(this).prop('checked')) {
            $('.welcome_btn').removeClass('disabled')
        } else {
            $('.welcome_btn').addClass('disabled')
        }
    });

    const mapPoints = document.querySelectorAll('.tp-point')
    mapPoints.forEach(point => {
        const content = point.getAttribute('data-answer')
        tippy(point, {
            trigger: 'click',
            placement: 'top-start',
            allowHTML: true,
            content: content,
        });
    });

    $('#staticBackdrop button').click(function () {
        $(this).parents('.modal').removeClass('show').hide()
        $('.modal-backdrop').removeClass('show').hide()
        $('body').removeClass('modal-open')
    })

    $(window).scroll(function () {
        var sticky = $('.header_main_area'),
            scroll = $(window).scrollTop();

        if (scroll >= 100) sticky.addClass('fixed');
        else sticky.removeClass('fixed');
    });
});

$('.footer_box_toggle h2').on('click', function () {
    $(this).parent().find('.toggle').slideToggle();
})


$('#inputTargetWeight, #inputHeight, #inputWeight, #inputWeightLbs, #inputTargetWeightLbs').keypress(function (e) {
    const weightUnit = $("input[name=weightUnit]:checked").val();
    //console.log(weightUnit)
    //if (weightUnit != "stone") {
    var regex = new RegExp("^[0-9]+$");
    var strigChar = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(strigChar)) {
        return true;
    }
    return false
    //}
});


$('#inputWeightLbs, #inputTargetWeightLbs').keyup(function (e) {
    const WeightLbsValue = parseInt($(this).val())
    if (WeightLbsValue > 13) {
        $(this).val(13)
    }
    console.log(WeightLbsValue)
});

$('#inputHeightInch').keyup(function (e) {
    const heightInchValue = parseInt($(this).val())
    if (heightInchValue > 11) {
        $(this).val(11)
    }
});



function bulkAddToCart(items) {
    const data = {
        items: items
    }

    fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => response.json())
        .then(cart => {
            console.log('Items added to cart:', cart);
            //window.location.href = '/checkout'
        })
        .catch(error => {
            console.error('Error adding items to cart:', error);
        });
}

async function proceedPayNow(items) {
    try {
        const response = await fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const cart = await response.json();
        console.log('Cart cleared:', cart);
        bulkAddToCart(items);

    } catch (error) {
        console.error('Error clearing the cart:', error);
    }
}

$(document).ready(function () {

    $(".product-group-tabs a").click(function (e) {
        const currentProduct = $(this).attr('href')
        setContent($(`${currentProduct} .varations-tabs li`).first().find('a'), true)
    });

    $('.varations-tabs a').click(function (e) {
        setContent($(this))
    });

    const setContent = (currentVariation, isParent = false) => {
        const currVar = $(currentVariation)
        console.log(currVar)
        if (isParent) {
            $('.varations-tabs a').removeClass('active')
            $('.product-variation-tab-content .tab-pane').removeClass('active show')
            currVar.addClass('active').show()
            const childFirstTabId = currVar.attr('href')
            $(childFirstTabId).addClass('active show')
            $(childFirstTabId).addClass(' fade')
        }

        $('.tab-product-image').attr('src', currVar.data('product-img-url'))
        const medicine = currVar.data('medicine')
        const treatmentPeriod = currVar.data('treatment-period')
        $('.medicine').text(medicine)
        $('.treatment').text(treatmentPeriod)
    }

    setContent($('#mounjaro .varations-tabs li').first().find('a'))

    //$('.variation-info .info-box').hide()
    $('.variation-info h3').addClass('active')
    $('.variation-info h3').click(function (e) {
        e.preventDefault();
        $('.variation-info h3').toggleClass('active')
        $('.variation-info .info-box').slideToggle(500);
    });

    $('.medicines-work .title-wrapper h2').addClass('active')
    $('.medicines-work .title-wrapper h2').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active')
        $('.medicines-work .row').slideToggle(500);

    });


    $('.medicine-info-title-block h2').click(function (e) {
        $('.maintenance-plan__medicine-info').toggleClass('active')
        $('.medicine-info-content-blocks').slideToggle()
    });

    $('.maintenance-plan__main-tabs .nav-link').click(function (e) {
        e.preventDefault();
        $('.variant-list input').prop('checked', false).attr('disabled', false);
        $('.mp-paynow-btn,.variant-list li').addClass('disabled')

        $('.variant-list li').removeClass('disabled')
        $('.variant-name').text('Select Medicine')

        const tabID = $(this).attr('href')
        const firstImageSrc = $(`${tabID} .variant-list li`).first().find('input').data('image-src')
        $('.tab-product-image').attr('src', firstImageSrc)
        $('.variant-selected').text(0)

    });


    $('.variant-list input').change(function (e) {
        console.log('hello')
        const checkedChoices = $('.variant-list input:checked')
        const checkBoxes = $('.variant-list input')
        const name = $(this).data('name')

        $('.variant-name').text(name)
        const imageSrc = $(this).data('image-src')
        $('.tab-product-image').attr('src', imageSrc)

        $('.variant-selected').text(checkedChoices.length)

        if (checkedChoices.length > 0 && checkedChoices.length <= 3) {
            for (let index = 0; index < checkBoxes.length; index++) {
                const checkbox = checkBoxes[index];
                if (!$(checkbox).is(':checked')) {
                    $('.mp-paynow-btn').removeClass('disabled').attr('disabled', false)
                    if (checkedChoices.length == 3) {
                        $(checkbox).attr('disabled', true)
                        $(checkbox).parents('li').addClass('disabled')
                    } else {
                        $(checkbox).attr('disabled', false)
                        $(checkbox).parents('li').removeClass('disabled')
                    }
                }
            }

        } else {
            for (let index = 0; index < checkBoxes.length; index++) {
                const checkbox = checkBoxes[index];
                $(checkbox).attr('disabled', false)
                $(checkbox).parents('li').removeClass('disabled')
                $('.mp-paynow-btn').attr('disabled', true).addClass('disabled')
            }
        }
    });

    $('.mp-paynow-btn').click(function (e) {
        e.preventDefault();
        const paymentButton = $('.mp-paynow-btn');
        const checkboxes = document.querySelectorAll('input[name="variants"]:checked');
        if (checkboxes.length > 0 && checkboxes.length <= 3) {
            paymentButton.attr('disabled', true).addClass('disabled')
            const items = Array.from(checkboxes).reduce((acc, checkbox, index) => {
                acc[index] = {
                    id: checkbox.value,
                    quantity: 1
                };
                return acc;
            }, {});
            proceedPayNow(items)
        }
    });

    $('.col5_inline_1 label').click(function (e) {
        e.preventDefault();
        if ($(this).parent('.col5_inline_1').find('input').prop('checked')) {
            $(this).parent('.col5_inline_1').find('input').prop('checked', false);
        } else {
            $(this).parent('.col5_inline_1').find('input').prop('checked', true);
        }
        console.log($(this).text())
        if ($(this).text() == "Confirm") {
            if ($(this).parent('.col5_inline_1').find('input').prop('checked')) {
                $('.welcome_btn').removeClass('disabled')
            } else {
                $('.welcome_btn').addClass('disabled')
            }
        }

    });

    $('.drop_arrow a').mouseover(function () {
        console.log('heelo')
        $('.submenu').show();
    });

    $('.submenu,.header_main_area').mouseleave(function () {
        $('.submenu').hide()
    });


    $('.xs-drop-menu > a').click(function (e) {
        e.preventDefault();
        $('.xs-sub-menu').toggle();
    });
    $('.main-video-carousel').on('translated.owl.carousel', function (event) {
        $('.mounjaro-video__image').show()

        document.querySelectorAll('video').forEach(function (video) {
            video.pause();
        });
    });
});


jQuery(document).ready(function ($) {
    // Prevent submenu toggle on main <a> click
    $('#shopify-section-custom-header mobile-header .angle-shape.xs-drop-menu .icon').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Toggle submenu inside the same parent li
        var $parentLi = $(this).closest('li');
        $parentLi.find('.xs-sub-menu').slideToggle();
        $parentLi.toggleClass('open'); // Optional: for active styling
    });

    // Let the link itself (text) work normally
    $('.angle-shape.xs-drop-menu .text').on('click', function (e) {
        // Allow navigation
        var href = $(this).closest('a').attr('href');
        if (href) {
            window.location.href = href;
        }
    });
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.faq-page button[data-target]');
  if (!btn) return;

  const targetSelector = btn.getAttribute('data-target');
  const panel = document.querySelector(targetSelector);
  if (!panel) return;

  const accordion = btn.closest('[id^="accordion-"]');

  // close other open items (accordion behavior)
  accordion?.querySelectorAll('.collapse.show').forEach(el => {
    if (el !== panel) el.classList.remove('show');
  });

  panel.classList.toggle('show');
});